import { useGetDashboardStatsQuery } from '../../services/admin.service'
import { useGetArtsWithoutInspirationsQuery } from '../../services/arts.service'
import { Card, Container, Row, Col, Alert, Table, Button } from 'react-bootstrap'
import { Movie } from '../../types/movie.types'
import { useNavigate } from 'react-router-dom'

function AdminDashboard(): JSX.Element {
  const navigate = useNavigate()
  const { data: stats, isLoading, error } = useGetDashboardStatsQuery({})
  const { data: movies = [], isLoading: isMoviesLoading, error: moviesError } = useGetArtsWithoutInspirationsQuery({}) as { data: Movie[]; isLoading: boolean; error: any }

  const handleGoToMovie = (movieId: number) => {
    navigate(`/arts/view/${movieId}?inspirations=true`)
  }

  if (isLoading) {
    return (
      <Container className="mt-4">
        <Alert variant="info">Loading dashboard data...</Alert>
      </Container>
    )
  }

  if (error) {
    return (
      <Container className="mt-4">
        <Alert variant="danger">
          Error loading dashboard data. Please try again later.
        </Alert>
      </Container>
    )
  }

  return (
    <Container className="mt-4">
      <h1>Admin Dashboard</h1>
      <Row className="mt-4">
        <Col md={4}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Total Users</Card.Title>
              <Card.Text className="display-4">{(stats as any)?.totalUsers || 0}</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Admin Users</Card.Title>
              <Card.Text className="display-4">{(stats as any)?.adminUsers || 0}</Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Regular Users</Card.Title>
              <Card.Text className="display-4">{(stats as any)?.regularUsers || 0}</Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card>
            <Card.Body>
              <Card.Title>System Status</Card.Title>
              <Card.Text>
                <strong>Last Updated:</strong>{' '}
                {(stats as any)?.lastUpdated ? new Date((stats as any).lastUpdated).toLocaleString() : 'N/A'}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <Card>
            <Card.Body>
              <Card.Title>Missing Inspirations</Card.Title>
              {isMoviesLoading ? (
                <Alert variant="info">Loading movies data...</Alert>
              ) : moviesError ? (
                <Alert variant="danger">Error loading movies without inspirations.</Alert>
              ) : movies.length === 0 ? (
                <Alert variant="warning">All movies have inspirations! 🎉</Alert>
              ) : (
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Title</th>
                      <th>Year</th>
                      <th>Creator</th>
                      <th>Category</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {movies.map((movie) => (
                      <tr key={movie.id}>
                        <td>{movie.id}</td>
                        <td>{movie.title}</td>
                        <td>{movie.year}</td>
                        <td>{movie.creatorName || 'N/A'}</td>
                        <td>{movie.category}</td>
                        <td>
                          <Button 
                            variant="primary" 
                            size="sm" 
                            onClick={() => handleGoToMovie(movie.id)}
                          >
                            Go to Movie
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default AdminDashboard
